// extracted by mini-css-extract-plugin
export default {"productPicker":"avRmL"};